import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';

import QueuedVendorBillsContainer from '../../containers/billing/QueuedVendorBills';
import AuthUserContainer from '../../containers/AuthUser';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AutorenewIcon from '@material-ui/icons/Autorenew';
// import OpenLink from '@material-ui/icons/OpenInNew';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import UploadLfEnergyCsvDialog from '../../components/Dialogs/UploadLfEnergyCsvDialog';
import invoiceIcon from '../../images/invoicePdf.svg';

import PendingIcon from '@material-ui/icons/AccessTime';
import ErrorTabIcon from '@material-ui/icons/Error';
import InvalidIcon from '@material-ui/icons/DeleteForever';
import SentIcon from '@material-ui/icons/Send';

//Tabs
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

const QUEUE_STATUS = {
	PENDING: 'PENDING',
	SKIPPED: 'SKIPPED',
	BILL_CREATED: 'BILL_CREATED',
	INVALID: 'INVALID',
	ERROR: 'ERROR',
};

const NCP_SUPPLIER_ID = 5;

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const commonColumns = [
	{
		sortId: 'queuedVendorBillId',
		displayId: 'queuedVendorBillId',
		label: 'Queue ID',
	},
	{
		sortId: 'dateCreated',
		displayId: 'dateCreatedFormatted',
		label: 'Queued Date',
	},
	{
		sortId: 'typeOfBill',
		displayId: 'typeOfBillDisplay',
		label: 'Type of Bill',
	},
	{
		sortId: 'billDate',
		displayId: 'billDateFormatted',
		label: 'Bill Date',
	},

	{
		sortId: 'billNumber',
		displayId: 'billNumber',
		label: 'Bill #',
	},

	{
		sortId: 'bolNumber',
		displayId: 'bolDisplay',
		label: 'BOL #',
	},
	{
		sortId: 'subOrderCount',
		displayId: 'subOrderDisplay',
		label: 'Sub Orders',
	},
	{
		sortId: 'total',
		displayId: 'totalDisplay',
		label: 'Total',
	},
];

const pendingColumns = [
	...commonColumns,
	{
		sortId: 'pendingReason',
		displayId: 'pendingReason',
		label: 'Pending Reason',
		isNotSortable: true,
	},
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];
const billCreatedColumns = [
	...commonColumns,
	{
		sortId: 'billCreatedDisplay',
		displayId: 'billCreatedDisplay',
		label: 'Bill Created',
	},
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const errorColumns = [
	...commonColumns,
	{
		sortId: 'errorDisplay',
		displayId: 'errorDisplay',
		label: 'Error',
		isNotSortable: true,
	},
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const invalidColumns = [
	...commonColumns,
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir}>
			{children}
		</Typography>
	);
}

const formatNum = new Intl.NumberFormat('en-US', {
	//style: 'currency',
	//currency: 'USD',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
}).format;

class QueuedVendorBills extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, issued: 1, invalid: 2 }[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'queuedVendorBillId',
			search: '',
			filterMap: {},
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			isInvalidOpen: false,
			isUploadCsvDialogOpen: false,
		};
	}

	componentDidMount() {
		const { queuedVendorBills, queuedVendorBillSearch } = this.props;

		if (!queuedVendorBills) {
			queuedVendorBillSearch({});
		} else {
			this.formatQueuedVendorBills();
		}
	}

	componentDidUpdate(prevProps) {
		const { queuedVendorBills } = this.props;
		if (prevProps.queuedVendorBills !== queuedVendorBills) {
			this.formatQueuedVendorBills();
		}
	}

	formatQueuedVendorBills = () => {
		const { classes, authUser } = this.props;
		const isAdmin = authUser && authUser.userId === 14;
		const {
			queuedVendorBills,
			//apGuideMap,
		} = this.props;
		const invalidRows = [];
		const pendingRows = [];
		const billCreatedRows = [];
		const errorRows = [];
		queuedVendorBills.forEach((queuedVendorBill) => {
			const {
				supplierId,
				queuedVendorBillId,
				dateCreated,
				billDate,
				total,
				queueStatus,
				// invalidReason,
				// csvResourceId,
				// billNumber,
				// bolNumber,
				vendorBillOrders,
				errors,
				pendingReason,
				createdVendorBillId,
				dateVendorBillCreated,
			} = queuedVendorBill;

			queuedVendorBill.subOrderCount = !_.isEmpty(vendorBillOrders) ? vendorBillOrders.length : 1;
			queuedVendorBill.subOrderDisplay = !_.isEmpty(vendorBillOrders) ? vendorBillOrders.length : 1;

			if (!_.isEmpty(vendorBillOrders)) {
				queuedVendorBill.bolDisplay = vendorBillOrders
					.map((vendorBillOrder) => vendorBillOrder.bolNumber)
					.join(', ');
			} else {
				queuedVendorBill.bolDisplay = queuedVendorBill.bolNumber;
			}

			queuedVendorBill.key = queuedVendorBillId;
			queuedVendorBill.typeOfBillDisplay =
				NCP_SUPPLIER_ID == supplierId ? 'LF (Formerly NCP) / Fuel' : 'PDI / Fuel';
			queuedVendorBill.dateCreatedFormatted = moment(dateCreated).format('M/D/YY h:mm a');
			queuedVendorBill.totalDisplay = formatNum(total);

			queuedVendorBill.billDateFormatted = moment(billDate).format('M/D/YY');

			queuedVendorBill.triageButtons = (
				<>
					<Button className={classes.button} onClick={() => this.handleTriage(queuedVendorBillId)}>
						Triage
					</Button>
				</>
			);

			queuedVendorBill.viewButton = (
				<>
					<Button className={classes.button} onClick={() => this.handleView(queuedVendorBillId)}>
						View
					</Button>
					{isAdmin && (
						<>
							<Tooltip title="Delete">
								<IconButton
									size="small"
									onClick={() => this.handleDeleteFromQueue(queuedVendorBillId)}
								>
									<DeleteIcon fontSize="small" />
								</IconButton>
							</Tooltip>
							<Tooltip title="Resubmit">
								<IconButton
									size="small"
									onClick={() => this.handleResubmit(queuedVendorBillId)}
								>
									<AutorenewIcon fontSize="small" />
								</IconButton>
							</Tooltip>
						</>
					)}
				</>
			);

			if (createdVendorBillId) {
				queuedVendorBill.billCreatedDisplay = (
					<>
						<Link to={`/billing/vendorBill/update/${createdVendorBillId}`}>
							Bill: {createdVendorBillId}
						</Link>
						<div style={{ fontSize: '1px', color: '#666' }}>
							Created:
							{moment(dateVendorBillCreated).format('M/D/YY h:mm a')}
						</div>
					</>
				);
			}

			console.log('errors', errors);
			if (!_.isEmpty(errors)) {
				queuedVendorBill.errorDisplay = errors.join(' ');
			}

			if (queueStatus === QUEUE_STATUS.PENDING && !pendingReason) {
				queuedVendorBill.pendingReason = 'Awaiting first match attempt';
			}

			console.log(queueStatus);
			if (queueStatus === QUEUE_STATUS.ERROR) {
				errorRows.push(queuedVendorBill);
			} else if (queueStatus === QUEUE_STATUS.SKIPPED || queueStatus === QUEUE_STATUS.INVALID) {
				invalidRows.push(queuedVendorBill);
			} else if (queueStatus === QUEUE_STATUS.BILL_CREATED) {
				billCreatedRows.push(queuedVendorBill);
			} else {
				pendingRows.push(queuedVendorBill);
			}
		});
		this.setState({ errorRows, invalidRows, billCreatedRows, pendingRows });
	};

	handleView = (queuedVendorBillId) => {
		this.props.history.push(`/billing/queuedVendorBill/view/${queuedVendorBillId}`);
	};

	handleDeleteFromQueue = (queuedVendorBillId) => {
		const { hideQueuedVendorBill, showErrors, queuedVendorBillSearch } = this.props;
		hideQueuedVendorBill({
			params: { queuedVendorBillId },
			callback: (err) => {
				if (err) {
					showErrors(err);
					return;
				}
				queuedVendorBillSearch({});
			},
		});
	};

	handleResubmit = (queuedVendorBillId) => {
		const { resubmitQueuedVendorBill, showErrors, queuedVendorBillSearch } = this.props;
		resubmitQueuedVendorBill({
			params: { queuedVendorBillId },
			callback: (err) => {
				if (err) {
					showErrors(err);
					return;
				}
				queuedVendorBillSearch({});
			},
		});
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleTriage = (queuedVendorBillId) => {
		this.setState({
			isInvalidOpen: true,
			queuedVendorBillIdForTriage: queuedVendorBillId,
		});
	};

	handleDocClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	handleOpenUploadCsvDialog = () => {
		this.setState({ isUploadCsvDialogOpen: true });
	};

	handleCloseUploadCsvDialog = () => {
		this.setState({ isUploadCsvDialogOpen: false });
	};

	handleAfterCsvUpload = () => {
		this.props.queuedVendorBillSearch({});
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const { classes, resourceMap, theme, authUser, uploadLfEnergyCsv } = this.props;
		const {
			pendingRows,
			billCreatedRows,
			errorRows,
			invalidRows,
			order,
			orderBy,
			isUploadCsvDialogOpen,
		} = this.state;

		if (!pendingRows) {
			return <div>Loading the queued vendor bills...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>Vendor Bill Queue</span>
							</Typography>
						</Grid>
						{authUser && authUser.userId === 14 && (
							<Grid item xs={4} style={{ textAlign: 'right' }}>
								<Button
									variant="contained"
									color="primary"
									onClick={this.handleOpenUploadCsvDialog}
								>
									Upload Bill CSV
								</Button>
							</Grid>
						)}
					</Grid>

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="Pending" icon={<PendingIcon />} />
							<Tab label="Errors" icon={<ErrorTabIcon />} />
							<Tab label="Bill Created" icon={<SentIcon />} />
							<Tab label="Invalid / Skipped" icon={<InvalidIcon />} />
						</Tabs>
					</AppBar>
					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={pendingColumns}
									rows={pendingRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={errorColumns}
									rows={errorRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={billCreatedColumns}
									rows={billCreatedRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={invalidColumns}
									rows={invalidRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
						</SwipeableViews>

						<ResourcePopup
							open={this.state.isResourcePopupOpen}
							onClose={this.handleCloseResourcePopup}
							resourceIds={this.state.resourceIdsPoppedUp}
							resourceMap={resourceMap}
						/>

						{/*
						<ConfirmInvalidateApArTriage
							open={this.state.isInvalidOpen}
							onClose={this.closeInvalidDialog}
							apIngestionResultId={this.state.queuedVendorBillIdForTriage}
							showErrors={this.props.showErrors}
						/>
		*/}
					</Paper>

				{isUploadCsvDialogOpen && (
					<UploadLfEnergyCsvDialog
						open={isUploadCsvDialogOpen}
						onClose={this.handleCloseUploadCsvDialog}
						onAfterUpload={this.handleAfterCsvUpload}
						uploadLfEnergyCsv={uploadLfEnergyCsv}
					/>
				)}
			</Grid>
		</Grid>
		);
	}
	closeInvalidDialog = () => {
		this.setState({ isInvalidOpen: false });
	};
}

QueuedVendorBills.propTypes = {
	classes: PropTypes.object.isRequired,
	queuedVendorBillSearch: PropTypes.func.isRequired,
	uploadLfEnergyCsv: PropTypes.func.isRequired,
	hideQueuedVendorBill: PropTypes.func.isRequired,
	resubmitQueuedVendorBill: PropTypes.func.isRequired,
	queuedVendorBills: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	supplierMap: PropTypes.object,
	resourceMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	QueuedVendorBillsContainer,
])(QueuedVendorBills);
